import { render, staticRenderFns } from "./alibabaCates.vue?vue&type=template&id=6c966534&scoped=true&"
import script from "./alibabaCates.vue?vue&type=script&lang=js&"
export * from "./alibabaCates.vue?vue&type=script&lang=js&"
import style0 from "./alibabaCates.vue?vue&type=style&index=0&id=6c966534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c966534",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/components/alibabaCates.vue
// module id = null
// module chunks = 